// extracted by mini-css-extract-plugin
module.exports = {"d1qau7n1":"d1qau7n1","focused":"focused"};